import GoogleIcon from './GoogleIcon'
import LogoIcon from './LogoIcon'

export {
    GoogleIcon,
    LogoIcon
}
